
import Button from '../base/Button';

export default function CTA() {
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Automate Your Invoices?
        </h2>
        <p className="text-xl text-blue-100 mb-10 max-w-3xl mx-auto">
          Join hundreds of SMBs already saving time and money with Ledger Linc. Start your free trial today or book a personalized demo.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-50 text-lg px-10">
            <i className="ri-play-circle-line mr-2 text-xl"></i>
            Start Free Trial
          </Button>
          <Button variant="secondary" size="lg" className="text-lg px-8">
            <i className="ri-discount-percent-line mr-2 text-xl"></i>
            Join Beta & Save 50%
          </Button>
          <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-600 text-lg px-8">
            <i className="ri-calendar-line mr-2 text-xl"></i>
            Book a Demo
          </Button>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-8 text-blue-100 text-sm">
          <div className="flex items-center">
            <i className="ri-check-circle-fill text-green-400 mr-2"></i>
            14-day free trial
          </div>
          <div className="flex items-center">
            <i className="ri-check-circle-fill text-green-400 mr-2"></i>
            No setup fees
          </div>
          <div className="flex items-center">
            <i className="ri-check-circle-fill text-green-400 mr-2"></i>
            Cancel anytime
          </div>
          <div className="flex items-center">
            <i className="ri-check-circle-fill text-green-400 mr-2"></i>
            Money-back guarantee
          </div>
        </div>
      </div>
    </section>
  );
}
